import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

interface ButtonProps
  extends React.PropsWithChildren<
    React.ButtonHTMLAttributes<HTMLButtonElement>
  > {
  isLoading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <button
        {...props}
        className={twMerge(
          "bg-transparent select-none cursor-default flex items-center gap-2 text-[var(--gray-a11)] hover:bg-[var(--gray-a3)] active:bg-[var(--gray-a4)] rounded-lg p-3 disabled:opacity-50 disabled:cursor-not-allowed",
          className
        )}
        ref={ref}
        disabled={props.disabled || props.isLoading}
      >
        {children}
      </button>
    );
  }
);
